// ─────────────────────────────────────────────────────────
//  DELT API-LAG — bruges af alle komponenter
//  Importeret fra App.js og udtrukne komponenter
// ─────────────────────────────────────────────────────────

// Chunked upload til OneDrive (understøtter filer op til 500MB)
export async function onedrive_upload(upload_url, fil, onProgress) {
  const CHUNK = 10 * 1024 * 1024; // 10MB chunks
  if (fil.size <= 4 * 1024 * 1024) {
    const res = await fetch(upload_url, {
      method: "PUT",
      headers: { "Content-Type": fil.type || "application/octet-stream", "Content-Range": `bytes 0-${fil.size-1}/${fil.size}` },
      body: fil,
    });
    if (onProgress) onProgress(100);
    if (!res.ok) throw new Error("Upload fejlede: " + res.status);
    return res;
  }
  let offset = 0;
  while (offset < fil.size) {
    const end = Math.min(offset + CHUNK, fil.size);
    const chunk = fil.slice(offset, end);
    const res = await fetch(upload_url, {
      method: "PUT",
      headers: { "Content-Length": String(end - offset), "Content-Range": `bytes ${offset}-${end-1}/${fil.size}` },
      body: chunk,
    });
    if (!res.ok && res.status !== 202) throw new Error("Chunk upload fejlede: " + res.status);
    offset = end;
    if (onProgress) onProgress(Math.round((offset / fil.size) * 100));
  }
}

export async function hent_csrf_token() {
  try {
    const cur = sessionStorage.getItem('sv_csrf_token');
    if (cur) return cur;
    const r = await fetch('/api/csrf', { credentials: 'include' });
    if (!r.ok) return null;
    const d = await r.json();
    if (d.csrf_token) {
      sessionStorage.setItem('sv_csrf_token', d.csrf_token);
      return d.csrf_token;
    }
  } catch(_) {}
  return null;
}

export async function api(sti, metode, data) {
  metode = metode || "GET";

  // Afbryd straks hvis lokalt token-exp viser at session er udløbet — undgår 401-logout ved fil-adgang
  try {
    const exp_ms = sessionStorage.getItem("sv_token_exp");
    if (exp_ms && parseInt(exp_ms, 10) <= Date.now()) {
      sessionStorage.removeItem("sv_bruger");
      sessionStorage.removeItem("sv_token_exp");
      window.location.reload();
      return null;
    }
  } catch (_) {}

  const csrf = ['GET','HEAD','OPTIONS'].includes(metode.toUpperCase()) ? null : await hent_csrf_token();
  const opts = {
    method: metode,
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
      ...(csrf ? { "X-CSRF-Token": csrf } : {}),
    },
  };
  if (data) opts.body = JSON.stringify(data);
  try {
    const res = await fetch("/api/" + sti.replace(/^\/+/, ''), opts);
    if (res.status === 401) {
      const was_logged_in = sessionStorage.getItem("sv_bruger") !== null;
      sessionStorage.removeItem("sv_bruger");
      sessionStorage.removeItem("sv_token_exp");
      if (was_logged_in) window.location.reload();
      return null;
    }
    return res.json();
  } catch (err) {
    console.error("API fejl:", err);
    if (window.__sv_toast) window.__sv_toast("Serverfejl — prøv igen", "fejl");
    return null;
  }
}
